import type { ExecutionStep } from '@shared/types/flow-executions';

/** Degraded data during a step (omitted or emptied mapping): written by the engine's
 * StepLogger.warning into `activity_log`. */
export const getStepWarnings = (step: Pick<ExecutionStep, 'activity_log'>): string[] =>
  (Array.isArray(step.activity_log) ? step.activity_log : [])
    .filter((event) => event.type === 'warning' && typeof event.message === 'string' && event.message.trim().length > 0)
    .map((event) => event.message);
